import './Placeholder.css';

import React from 'react';

const Placeholder = ({ children, className }) => {
  return <div className={className || 'Placeholder__root'}>{children}</div>;
};

export default Placeholder;
